import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TickerBar from './components/TickerBar';
import LatestSection from './components/LatestSection';
import GenreSection from './components/GenreSection';
import CollectionSection from './components/CollectionSection';
import BluraySection from './components/BluraySection';
import ChartSection from './components/ChartSection';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  const [query, setQuery] = useState('');

  const handleHeroSearch = () => {
    const el = document.getElementById('latest');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} onSearch={handleHeroSearch} />
        <TickerBar />
        <LatestSection query={query} onQueryChange={setQuery} />
        <GenreSection />
        <CollectionSection />
        <BluraySection />
        <ChartSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}